<div class="field grid">
    <label class="col-fixed">Select Entity Lister</label>
    <div class="col-fixed dropdown-field">
        <p-dropdown hideDropdownOnScroll (onChange)="updateListerColumns($event)" [options]="selectableListers" appendTo="body" placeholder="Select Entity Lister" [style]="{'width': '100%'}"></p-dropdown>
    </div>
        
    </div>
    <div class="field grid" *ngIf="selectedListerConfig.length > 0">
        <label class="col-fixed">Columns</label>

        <p-table responsiveLayout="scroll" [value]="selectedListerConfig" class="mojo-admin-page data-table">
        <ng-template pTemplate="header">
            <tr>
                <th>Columns</th>
                <th>
                    Allowed?
                    <div class="centered-checkbox">
                        <input type="checkbox" [checked]="handleAllowAllColumnsChecked()" (change)="handleAllowAllChange($event)"/>
                    </div>
                </th>
                <th>
                    Default?
                    <div class="centered-checkbox">
                        <input type="checkbox" [checked]="handleDefaultAllColumnsChecked()" (change)="handleDefaultAllChange($event)" />
                    </div>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-column>
            <tr>
                <td>{{column.ColDef.Header}}</td>
                <td>
                    <div class="centered-checkbox">
                        <input type="checkbox" (change)="handleAllowedColumnChange(column)" [(ngModel)]="column.Allowed" [binary]="true" [ngModelOptions]="{standalone: true}">
                    </div>
                </td>
                <td>
                    <div class="centered-checkbox">
                        <input type="checkbox" (change)="handleDefaultColumnChange(column)" [(ngModel)]="column.Default" [binary]="true" [ngModelOptions]="{standalone: true}">
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>